import React, { useEffect, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import { Box, CircularProgress } from "@mui/material";
import CustomPagination from "../../components/pagination";
import { useNavigate } from "react-router-dom";
import { profileAssumptionService } from "../../utils/services/profileAssumptionService";
import ProfileAssumptionList from "../../components/profile-assumption-list";
import ProfileAssumptionModal from "../../components/profile-assumption-modal";
import buildQuery from "../../utils/query-builder";

const ProfileAssumption = () => {
  const [selectedData, setSelectedData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [profileAssumptionList, setProfileAssumptionList] = useState([]);
  const [viewMode, setViewMode] = useState("list");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const [dataCount, setDataCount] = useState(rowsPerPage);
  const [loading, setLoading] = useState(false);
  const [openProfileAssumptionModal, setOpenProfileAssumptionModal] =
    useState(false);
  const fetchProfileAssumption = async () => {
    setLoading(true);
    try {
      const response = await profileAssumptionService.fetch(
        null,
        buildQuery({ limit: rowsPerPage, skip: page * rowsPerPage }),
      );
      setProfileAssumptionList(response.data);
      setLoading(false);
      setDataCount(response?.total);
    } catch (error) {
      console.error("Fetch failed:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchProfileAssumption();
  }, [page, rowsPerPage]);

  return (
    <>
      <DashboardContainer
        filterButton={false}
        hideUploadButton
        header={"Profile Assumption"}
        title={"+ Profile Assumption"}
        onClickAddButton={() => setOpenProfileAssumptionModal(true)}
        setViewMode={setViewMode}
        hideFilterClient={true}
        onClickRefresh={() => fetchProfileAssumption()}
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 9999,
              color: "white",
            }}
          >
            <CircularProgress color="inherit" />
          </Box>
        ) : (
          <ProfileAssumptionList
            dataCount={dataCount}
            currentPage={page}
            itemsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            setPage={setPage}
            onDeleteData={fetchProfileAssumption}
            onEditData={(e) => {
              setSelectedData(e);
              setOpenProfileAssumptionModal(true);
            }}
            data={profileAssumptionList}
            viewMode={viewMode}
            selectedProfileAssumption={selectedData}
            setSelectedProfileAssumption={setSelectedData}
          />
        )}
      </DashboardContainer>
      <CustomPagination
        dataCount={dataCount}
        rowsPerPage={rowsPerPage}
        page={page}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        disableNext={dataCount <= rowsPerPage * (page + 1)}
      />
      <ProfileAssumptionModal
        open={openProfileAssumptionModal}
        onClose={() => {
          setOpenProfileAssumptionModal(false);
          setSelectedData(null);
        }}
        editData={selectedData}
        onSuccess={() => {
          fetchProfileAssumption();
          setSelectedData(null);
        }}
      />
    </>
  );
};

export default ProfileAssumption;
